import { styled } from '@mui/system';
import { Tabs as BaseTabs } from '@mui/base/Tabs';
import { TabsList as BaseTabsList } from '@mui/base/TabsList';
import { TabPanel as BaseTabPanel } from '@mui/base/TabPanel';
import { buttonClasses } from '@mui/base/Button';
import { Tab as BaseTab, tabClasses } from '@mui/base/Tab';
import { Card } from '@mui/material'; // IssueCardのためにCardをインポート

export const blue = {
  50: '#F0F7FF',
  100: '#C2E0FF',
  200: '#80BFFF',
  300: '#66B2FF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  700: '#0059B2',
  800: '#004C99',
  900: '#003A75',
};

export const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

export const Tab = styled(BaseTab)`
  color: white;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 7px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${blue[400]};
  }

  &:focus {
    color: #fff;
    outline: 3px solid ${blue[200]};
  }

  &.${buttonClasses.focusVisible} {
    background-color: #fff;
    color: ${blue[600]};
  }

  &.${tabClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.${tabClasses.selected} {
    background-color: #fff;
    color: ${blue[600]};
  }
`;

export const TabPanel = styled(BaseTabPanel)`
  width: 100%;
  font-size: 0.875rem;
`;

export const IssueCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
  height: 80%;
  margin: 5% auto;
  padding: 10px;
  box-shadow: 5px 4px 20px 1px gray;
`;

export const IssueCardMobile = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 95%;
  height: auto;
  margin: 2% auto;
  padding: 10px;
  box-shadow: 5px 4px 20px 1px gray;
`;

export const Tabs = styled(BaseTabs)`
  display: flex;
  gap: 16px;
  width: 100%;
  height: 100%;
`;

export const TabsListMobile = styled(BaseTabsList)(
  ({ theme }) => `
  width: 100%;
  background-color: ${blue[500]};
  display: flex;
  padding: 6px;
  gap: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px ${theme.palette.mode === 'dark' ? grey[900] : grey[200]};
  `,
);

export const TabsList = styled(BaseTabsList)(
  ({ theme }) => `
  min-width: 100px;
  width: 20vw;
  background-color: ${blue[500]};
  display: flex;
  padding: 6px;
  gap: 12px;
  flex-direction: column;
  align-items: center;
  place-content: space-between center;
  box-shadow: 0 4px 8px ${theme.palette.mode === 'dark' ? grey[900] : grey[200]};
  `,
);
